import { Box } from "@mui/material";
import React from "react";
import Map from "src/components/map";
import _socialLink from "./_social-links";

const SocialLinks = () => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "repeat(4, 1fr)", // mobile
          sm: "repeat(5, 1fr)", // tablet
          md: "repeat(5, 1fr)", // laptop
        },
        ml: "-8px",
        maxWidth: "200px",
      }}
    >
      <Map
        list={_socialLink}
        render={({ href, title, icon }) => (
          <Box
            component="a"
            href={href}
            target="_blank"
            rel="noreferrer"
            title={title}
            sx={{
              width: 45,
              height: 45,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.3s ease",
              "&:hover": {
                transform: "translateY(-3px)",
              },
            }}
          >
            <Box
              component="img"
              src={icon.trim()}
              alt={title}
              sx={{
                width: 28,
                height: 28,
                objectFit: "contain",
              }}
            />
          </Box>
        )}
      />
    </Box>
  );
};

export default SocialLinks;